<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Taksitliler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        title: "TAKSİTLİLER",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "TAKSİTLİLER",
          active: true,
        }],
        isLoading: false,
        form:{
            user_id:"",
            startdate:'',
            startdateend:''
        },
        rows: [],
        totalRecords: 0,
        serverParams: {
            columnFilters: {
            },
            sort: [
            {
                field: '',
                type: '',
            },
            ],
            page: 1,
            perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        url: "/reports/taksitliler",
        paginationOptions: {
            enabled: true,
            dropdownAllowAll: false,
            perPage: 50,
            setCurrentPage: 1,
            perPageDropdown: [50, 100, 200],
            nextLabel: 'Sonraki',
            prevLabel: 'Önceki',
            rowsPerPageLabel: 'Kayıt Göster',
            ofLabel: 'of',
            pageLabel: 'sayfa', // for 'pages' mode
            infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
        },
        columns: [ 
            {
                label: 'Müşteri Kullanıcı Adı',
                field: 'username',
                sortable: false,
            },
            {
                label: 'Müşteri İsim Soyisim',
                field: this.fullname,
                sortable: false,
            },
            {
                label: 'Kalan Taksit',
                field: this.remaining,
                sortable: false,
            },
            {
                label: 'Bir Sonraki Taksit Günü',
                field: 'installment_expiredate',
                sortable: false,
            },
            {
                label: '#',
                field: '#',
                sortable: false,
            },
        ],
    };
  },
  mounted() {
    this.loadItems()
  },
  methods: {
        fullname(obj){
            return obj.fname + ' ' + obj.lname; 
        },

        remaining(obj){
            return obj.installment.remaining; 
        },
        
        iptal(props){
            this.$http.post('/taksit-iptal', { id:props.id })
            .then(() => this.loadItems())
        },
    
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({sort: params})
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
                this.info = response.info
            
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                    rows: res.data.data,
                    info: res.data.info,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                    })
                })
                .catch(error => {reject(error)})
            })
        },
        formSubmit(){
            this.updateParams({columnFilters : {...this.form}});
            this.loadItems()
        },

        filter(){
            this.updateParams({columnFilters : {...this.form}});
            this.loadItems()
        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
   <div class="row mb-3">
        <div class="col-xl-3">
          <div class="mb-3">
            <label>Müşteri İsmi </label>
            <input type="text" v-model="form.fullname" @input="filter()" class="form-control" />
          </div>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote" 
                :line-numbers="true"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <b-dropdown
                    v-if="props.column.field === '#'"
                    class="ms-2 "
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    right
                >
                    <template #button-content>
                      <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <template>
                        <b-dropdown-item @click="iptal(props.row)">İptal Et</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>